import styled from "styled-components";
const disabledMenuItemStyle = (theme) => `color: ${theme.colors.black};
opacity: 26%;
border: 1px ${theme.colors.black};
cursor: text;`;
const disabledMenuItemSelectedStyle = (theme) => `
background-color: ${theme.colors.grey15};
color: ${theme.colors.white};`;
export const StyledLi = styled.li `
  &&& {
    list-style: none;

    .disabled,
    .disabled:hover,
    .disabled:active {
      a {
        color: rgba(${({ theme }) => theme.colors.transparentBlack},0.26);
      }
    }
    ${({ isDisabled, theme }) => isDisabled ? disabledMenuItemStyle(theme) : ""};
    & > a {
      all: unset;
      outline: none;
      padding-left: 0.5rem;
      display: flex;
      align-items: center;
      height: 2.5rem;
      box-sizing: border-box;
      font-size: ${({ theme }) => theme.fontTokens.font12[0]};
      line-height: ${({ theme }) => theme.fontTokens.font12[1]};
      color: ${({ isActive, theme }) => isActive ? theme.colors.primaryLight : theme.colors.black};
      border-bottom-color: ${({ isActive, theme }) => isActive ? theme.colors.primaryLight : "transparent"};
      font-weight: ${({ theme }) => theme.fontWeights.medium};

      ${({ focusVisible, theme }) => focusVisible ? `outline: 2px solid ${theme.colors.primaryLight}` : ""};
      &:hover {
        background-color: ${({ isDisabled, theme }) => isDisabled
    ? theme.colors.white
    : `rgba(${theme.colors.transparentBlack},0.08)`};
      }  
      &:active {
        ${({ isDisabled, theme }) => !isDisabled || isDisabled === undefined
    ? disabledMenuItemSelectedStyle(theme)
    : ""}
      }

      span {
        margin-left: auto;
      }
    }
  }
`;
